import { FC, Fragment } from 'react'
import { Field } from 'formik'
import { StyleButton, StyleButtonItemsWrapper } from './style'
import { StyleLabel, StyleFormWrapper } from '../style'
import ErrorMessage from '../ErrorMessage'
interface ChooseButtonProps {
  items: any[]
  titleAsKey: string
  valueAsKey: string
  name: string
  label?: string
  onChange?: (values: any[]) => void
  styleFormWrapper?: string
  styleWrapper?: string
  styleButton?: string
  multiple?: boolean
  disabled?: boolean
}
const ChooseButton: FC<ChooseButtonProps> = ({
  items,
  titleAsKey,
  valueAsKey,
  name,
  label,
  onChange,
  styleFormWrapper = '',
  styleWrapper = '',
  styleButton = '',
  multiple = true,
  disabled = false,
}) => {
  const handleClick = ({ form, field, value }) => {
    if (!!multiple) {
      const values = [...(field.value || [])]
      if (field.value.includes(value)) {
        values.splice(values.indexOf(value), 1)
      } else {
        values.push(value)
      }
      if (!!onChange) {
        onChange(values)
      } else {
        form.setFieldValue(name, values)
      }
    } else {
      if (!!onChange) {
        onChange(value)
      } else {
        form.setFieldValue(name, value)
      }
    }
  }
  return (
    <Field name={name}>
      {({ form, field, meta }) => {
        const hasError = meta.error

        return (
          <StyleFormWrapper styleWrapper={styleFormWrapper}>
            {!!label && <StyleLabel>{label}</StyleLabel>}
            <StyleButtonItemsWrapper styleWrapper={styleWrapper}>
              {items.map((item: any, index: number) => {
                return (
                  <Fragment key={index}>
                    <StyleButton
                      type="button"
                      styleButton={styleButton}
                      isActive={
                        !!multiple
                          ? !!field?.value?.includes(item?.[valueAsKey])
                          : field.value == item[valueAsKey]
                      }
                      disabled={disabled}
                      onClick={() =>
                        handleClick({
                          form,
                          field,
                          value: item?.[valueAsKey],
                        })
                      }
                    >
                      {!!item?.render ? item?.render(item) : item?.[titleAsKey]}
                    </StyleButton>
                  </Fragment>
                )
              })}
            </StyleButtonItemsWrapper>
            {!!hasError && <ErrorMessage message={meta.error} />}
          </StyleFormWrapper>
        )
      }}
    </Field>
  )
}

export default ChooseButton
